export default axios => ({
    list(payload) {
        return axios.get('/loyalty/item/list', payload);
    },
    history(userId, payload) {
        return axios.get(`/loyalty/${userId}/history`, payload);
    },
    change(userId, payload) {
        return axios.post(`/loyalty/${userId}/change`, payload);
    },
    delete(userId, historyId) {
        return axios.delete(`/loyalty/${userId}/${historyId}`);
    },
    get(userId, history_id) {
        return axios.get(`/loyalty/${userId}/${history_id}`);
    },
})
